import React, { useState } from 'react'

import TimeDaysAndTimes from '@/legacy-src/components/filters/timeFilters/TimeDaysAndTimes'
import TimeInXDays from '@/legacy-src/components/filters/timeFilters/TimeInDaysCount'
import Icon from '@/legacy-src/components/icons/Icon'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/legacy-src/components/ui/accordion'

import { TherapistFilterMenuTriggerUI } from '@/src/domains/therapist-filters/components/TherapistFilterMenuTrigger'

import { getTranslate } from '../../../utilities/i18n'
import useOutsideClick from '../../../utilities/useClickOutside'

const Trigger: React.FC<{ children: React.ReactNode; iconName: string }> = ({ children, iconName }) => {
  return (
    <div className="flex items-center gap-3">
      <Icon icon={iconName} size="sm" className="text-primary" />
      <span className="font-bold">{children}</span>
    </div>
  )
}

const TimeFilters: React.FC = () => {
  const { t } = getTranslate()
  const [isOpen, setIsOpen] = useState(false)

  const handleClickOutside = () => setIsOpen(false)
  const ref = useOutsideClick(handleClickOutside)
  const toggleOpen = () => setIsOpen((prev) => !prev)

  return (
    <div ref={ref}>
      <TherapistFilterMenuTriggerUI icon="calendar" onClick={toggleOpen} data-state={isOpen ? 'open' : 'closed'}>
        {t('component.button.timeFiler')}
      </TherapistFilterMenuTriggerUI>

      {isOpen && (
        <div className="absolute left-0 z-[1050] mt-2 w-full rounded-xl bg-white shadow-hedepy tablet:left-auto tablet:w-96">
          <div className="rounded-xl px-5 py-1">
            <Accordion type="single" collapsible defaultValue="in-x-days">
              <AccordionItem value="in-x-days">
                <AccordionTrigger>
                  <Trigger iconName="video">{t('components.filter.inXDays.title')}</Trigger>
                </AccordionTrigger>
                <AccordionContent>
                  <TimeInXDays />
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="days-and-times">
                <AccordionTrigger>
                  <Trigger iconName="clock">{t('components.filter.availableAtTimes.title')}</Trigger>
                </AccordionTrigger>
                <AccordionContent>
                  <TimeDaysAndTimes />
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      )}
    </div>
  )
}

export default TimeFilters
